import { render, staticRenderFns } from "./DmpArea.vue?vue&type=template&id=7247629a&scoped=true"
import script from "./DmpArea.vue?vue&type=script&lang=js"
export * from "./DmpArea.vue?vue&type=script&lang=js"
import style0 from "./DmpArea.vue?vue&type=style&index=0&id=7247629a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7247629a",
  null
  
)

export default component.exports